import apiClient from './apiClient';
import { VoiceTranscriptionResponse, VoiceSynthesisOptions } from '../types';

export type VoiceTranscriptionResult = VoiceTranscriptionResponse;

export interface VoiceTranscriptionOptions {
  sessionId?: string | null;
  filename?: string;
  mimeType?: string;
}

export async function transcribeVoice(
  audioBlob: Blob,
  options: VoiceTranscriptionOptions = {},
): Promise<VoiceTranscriptionResult> {
  const formData = new FormData();
  const fileName = options.filename || `voice-${Date.now()}.webm`;
  formData.append('file', audioBlob, fileName);
  if (options.sessionId) {
    formData.append('session_id', options.sessionId);
  }

  const response = await apiClient.post<VoiceTranscriptionResult>('/chat/transcribe', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
}

export interface VoiceSynthesisResult {
  blob: Blob;
  mimeType: string;
}

export async function synthesizeSpeech(
  text: string,
  options: VoiceSynthesisOptions = {},
): Promise<VoiceSynthesisResult> {
  const payload: Record<string, unknown> = { text };
  if (options.voiceId) {
    payload.voice_id = options.voiceId;
  }
  if (options.modelId) {
    payload.model_id = options.modelId;
  }
  if (options.mimeType) {
    payload.mime_type = options.mimeType;
  }
  if (typeof options.speakingRate === 'number') {
    payload.speaking_rate = options.speakingRate;
  }
  if (typeof options.pitch === 'number') {
    payload.pitch = options.pitch;
  }
  if (options.voicePreset) {
    payload.voice_preset = options.voicePreset;
  }

  const response = await apiClient.post<ArrayBuffer>('/chat/speak', payload, {
    responseType: 'arraybuffer',
  });

  const contentType = response.headers['content-type'] || 'audio/mpeg';
  const audioBlob = new Blob([response.data], { type: contentType });
  return {
    blob: audioBlob,
    mimeType: contentType,
  };
}
